import { render, staticRenderFns } from "./IntroCard.vue?vue&type=template&id=77dd73ac&scoped=true"
import script from "./IntroCard.vue?vue&type=script&lang=js"
export * from "./IntroCard.vue?vue&type=script&lang=js"
import style0 from "./IntroCard.vue?vue&type=style&index=0&id=77dd73ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dd73ac",
  null
  
)

export default component.exports